var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"father"},[_c('div',{staticClass:"head"},[_vm._v("header")]),_vm._v(" "),_c('div',{staticClass:"side"},[_vm._v("side")]),_vm._v(" "),_c('div',{staticClass:"main"},[_vm._v("main")]),_vm._v(" "),_c('div',{staticClass:"foot"},[_vm._v("foot")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aaa869e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Test.vue
// module id = null
// module chunks = 